// src/components/GlobalError.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

const GlobalError = ({ errorMessage, onRetry }) => {
    if (!errorMessage) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                textAlign: 'center',
                gap: 2,
                px: 2,
            }}
        >
            <ErrorOutline sx={{ fontSize: 48, color: 'error.main' }} />
            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                {errorMessage}
            </Typography>
            {onRetry && (
                <Button
                    variant="outlined"
                    startIcon={<Refresh />}
                    onClick={onRetry}
                //color="error"
                >
                    再試行
                </Button>
            )}
        </Box>
    );
};

export default GlobalError;